module.exports = __webpack_public_path__ + "img/Pascal.b5928289.png";